import React from 'react';

function WebhookLine({ webhook }) {
    const getStatusBadgeClass = (status) => {
        status = status?.toLowerCase() || '';

        if (status.includes('success') || status.includes('delivered') || status.includes('completed')) {
            return 'bg-green-100 text-green-700 border border-green-200';
        } else if (status.includes('pending') || status.includes('retry') || status.includes('processing')) {
            return 'bg-yellow-100 text-yellow-700 border border-yellow-200';
        } else if (status.includes('fail') || status.includes('error') || status.includes('timeout')) {
            return 'bg-red-100 text-red-700 border border-red-200';
        } else {
            return 'bg-gray-100 text-gray-700 border border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (e) {
            return dateString;
        }
    };

    return (
        <tr key={webhook?.id} className="hover:bg-gray-50 transition-colors duration-150">
            <td className="whitespace-nowrap px-4 py-4 first:pl-6 text-sm text-gray-600 font-mono">{webhook?.executedFrom ?? ''}</td>
            <td className="px-4 py-4 text-sm text-gray-600 max-w-md">
                <div className="truncate" title={webhook?.endpoint ?? ''}>
                    {webhook?.endpoint ?? ''}
                </div>
            </td>
            <td className="whitespace-nowrap px-4 py-4 text-sm">
                <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium ${getStatusBadgeClass(webhook?.status)}`}>
                    {webhook?.status ?? ''}
                </span>
            </td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-600 font-mono">{webhook?.responseCode ?? ''}</td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-600">{formatDate(webhook?.createdAt)}</td>
        </tr>
    );
}

export default WebhookLine;
